import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface StatCardProps {
  label: string;
  value: ReactNode;
  icon?: LucideIcon;
  hint?: ReactNode;
  tone?: 'default' | 'success' | 'warn' | 'danger';
  className?: string;
}

const TONE_STYLES = {
  default: 'text-foreground',
  success: 'text-emerald-400',
  warn: 'text-amber-400',
  danger: 'text-rose-400',
} as const;

export function StatCard({ label, value, icon: Icon, hint, tone = 'default', className }: StatCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-card p-4 flex flex-col gap-1.5',
        className,
      )}
    >
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span className="uppercase tracking-wider">{label}</span>
        {Icon && <Icon className="h-3.5 w-3.5" />}
      </div>
      <div className={cn('text-2xl font-semibold tabular-nums', TONE_STYLES[tone])}>
        {value}
      </div>
      {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
